import { createContext } from 'utils/react/createContext';
import { UseSelectReturn } from './UseSelect';

export const [SelectContextProvider, useSelectContextProvider] =
  createContext<UseSelectReturn>();
